export class AdminIdeaUpdatesDeleteRequest {
  ideaId!: string
  updateId!: string
}
